import script from "./ChassisSectionFrameAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./ChassisSectionFrameAgreement.vue?vue&type=script&setup=true&lang=js"

import "./ChassisSectionFrameAgreement.vue?vue&type=style&index=0&id=76560e8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76560e8b"]])

export default __exports__